const resetActionTypes = {
  RESET_STATE: 'RESET_STATE',
  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
  RESET_PASSWORD_INVALID_PASSWORD_FAILURE: 'RESET_PASSWORD_INVALID_PASSWORD_FAILURE',
};

export { resetActionTypes as default };
